import React, {useState} from 'react';
import "../../../assets/styles/_utilityClasses.scss"
import './humanCallScore.scss';
import {AccordionDetails, AccordionSummary} from "@mui/material";
import {ReactComponent as ExpandMoreIcon} from "../../../assets/icons/ExpandMore.svg";
import ChooseFile from "../../ChooseFile/ChooseFile";
import ChooseCriteriaOrScoreCard from "./HumanCallScoreSteps/ChooseCriteriaOrScoreCard/ChooseCriteriaOrScoreCard";
import StepsAccordion from "../../StepsAccordian/StepsAccordion";
import HumanCallScoreReport from "../HumanCallScoreReport/HumanCallScoreReport"
import {aiAgentEvaluationCriteria, humanEvaluationCriteria} from "../../../data/criterias";
import {addScoreCard, generateCallScore, generateCallScoreViaTextApi, createCriteria as addCriteria, fetchCriteriaById } from "../../../services/callScore";
import {useNavigate} from "react-router-dom";
import { HUMAN_SALES_CALL_TRANSCRIPT, HUMAN_SUPPORT_CALL_TRANSCRIPT } from "../../../data/transcript"

const HumanCallScore = ({ evaluateAiAgent = false }) => {
    const [customFileSelected, setCustomFileSelected] = useState(null);
    const [sampleFileSelected, setSampleFileSelected] = useState(null);
    const [criteriasAvailable, setCriteriasAvailable] = useState([]);
    const [criteriaIdsSelected, setCriteriaIdsSelected] = useState([]);
    const [scoreCardName, setScoreCardName] = useState('');
    const [scoreCards, setScoreCards] = useState([]);
    const [selectedScoreCardId, setSelectedScoreCardId] = useState(null);
    const [conversationId, setConversationId] = useState(null);
    const [jobId, setJobId] = useState(null);
    const [expandedStep1, setExpandedStep1] = useState(true);
    const [expandedStep2, setExpandedStep2] = useState(false);
    const [fileSelected, setFileSelected] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    
    React.useEffect(() => {
        if (evaluateAiAgent) {
            setCriteriasAvailable(aiAgentEvaluationCriteria)
        } else {
            setCriteriasAvailable(humanEvaluationCriteria)
        }
    }, [evaluateAiAgent])

    const navigate = useNavigate();
    console.log('this is customFileSelected', customFileSelected)

    const handleCustomFileSelected = (file) => {
        setSampleFileSelected(null);
        setCustomFileSelected(file);
        setFileSelected(true);
    };

    const handleSampleFileSelected = (file) => {
        console.log('this is file', file)
        setCustomFileSelected(file)
        setSampleFileSelected(file);
        setFileSelected(true);
    };

    const handleCriteriaSelection = (name, checked) => {
        const index = criteriaIdsSelected.indexOf(name);

        if (checked && index === -1) {
            setCriteriaIdsSelected(scoreCards => [...scoreCards, name])
            setSelectedScoreCardId('')
        } else if (!checked && index !== -1) {
            setCriteriaIdsSelected((scoreCards) => {
                const clone = [...scoreCards];
                clone.splice(index, 1)
                return clone;
            })
        }
    }

    const handleScoreCardNameChange = (text) => {
        setScoreCardName(text)
    }

    const handleStoryCardSelect = (storyCardId, checked) => {
        if(checked) {
            setSelectedScoreCardId(storyCardId);
            setCriteriaIdsSelected([])
        } else {
            setSelectedScoreCardId(null);
        }
    }

    const createScoreCard = async () => {
        try {
            console.log('Creating score card...');
            const cardName = scoreCardName;
            console.log('Score card name:', cardName);
    
            const filteredCriteria = criteriasAvailable.filter(criteria => criteriaIdsSelected.indexOf(criteria.id) !== -1);
            console.log('this is criteriasAvailable', criteriasAvailable)
            console.log('Filtered criteria:', filteredCriteria);
    
            const addedScoreCard = await addScoreCard({ name: cardName, criteriaList: filteredCriteria.map(criteria => criteria.id) });
            
            console.log('Score card added successfully:', addedScoreCard);

            const criteriaNames = []
            let criteria;
            const predefinedCriteriaIds = humanEvaluationCriteria.map(criteria => criteria.id)
            for (const criteriaId of addedScoreCard.criteriaList) {
                if (predefinedCriteriaIds.includes(criteriaId)) {
                    const criteriaResponse = humanEvaluationCriteria.find(criteria => criteria.id === criteriaId)
                    criteria = criteriaResponse.name
                } else {
                    const criteriaResponse = await fetchCriteriaById(criteriaId)
                    criteria = criteriaResponse.name
                }
                
                criteriaNames.push(criteria)
            }

            console.log('These are criteriaNames', criteriaNames)
            addedScoreCard["criteriaNames"] = criteriaNames
    
            setScoreCards(prevScoreCards => [...prevScoreCards, addedScoreCard]);
            console.log('Updated score cards state:', [...scoreCards, addedScoreCard]);
    
            setSelectedScoreCardId(addedScoreCard.id);
            console.log('Updated selected score card ID:', addedScoreCard.id);
    
            setScoreCardName('');
            setCriteriaIdsSelected([]);
            console.log('Reset score card name and selected criteria IDs');

            return addedScoreCard;
        } catch (error) {
            console.error('An error occurred while creating score card:', error);
            throw error;
        }
    }

    const handleGenerateCallScore = async () => {
        const fileBlob = customFileSelected,
            sampleFileName = sampleFileSelected,
            scoreCard = !!selectedScoreCardId ? scoreCards.find(_ => _.id === selectedScoreCardId) : null,
            criteriaIds = criteriaIdsSelected

        const scorecardId = scoreCard.id
        
        let data;
        setIsLoading(true)

        if (sampleFileName === 'SALES_CALL') {
            console.log('Generating callscore for sample sales call..')
            data = await generateCallScoreViaTextApi(HUMAN_SALES_CALL_TRANSCRIPT, scorecardId, 'sales')
        } else if (sampleFileName === 'CUSTOMER_SUPPORT_CALL') {
            console.log('Generating callscore for sample support call')
            data = await generateCallScoreViaTextApi(HUMAN_SUPPORT_CALL_TRANSCRIPT, scorecardId)
        } else {
            data = await generateCallScore(fileBlob, sampleFileName, scorecardId, criteriaIds);
        }

        console.log('this is data', data);
        if (data && data.conversationId) {
            setConversationId(data.conversationId)
            setJobId(data.jobId)
        }
    }

    const createCriteria = async ({ name, description, checklist }) => {
        try {
            console.log('Creating criteria...');
            const criteria = await addCriteria({ name, description, checklist });
    
            if (criteria) {
                console.log('Criteria created successfully:', criteria);
                setCriteriasAvailable(prevCriterias => [criteria, ...prevCriterias]);
            } else {
                console.error('Failed to create criteria. Response:', criteria);
                throw new Error('Failed to create criteria');
            }

            return criteria
        } catch (error) {
            console.error('An error occurred while creating criteria:', error);
            throw error;
        }
    };

    const navigateToCallScore = () => {
        navigate('/');
    }

    const disableGenerateScoreButton = !customFileSelected && !sampleFileSelected;

    const handleChangeStep1 = () => {
        setExpandedStep1(prevExpanded => !prevExpanded);
    };
    
    const handleChangeStep2 = () => {
        setExpandedStep2(prevExpanded => !prevExpanded);
    };
    
      const handleNextStep = () => {
        setExpandedStep1(false);
        setExpandedStep2(true);
      };

    return (
      <div className="generate-call-score-container">
          <div className={"call-score-options"}>
              <div>
              <StepsAccordion
                    expanded={expandedStep1}
                    onChange={handleChangeStep1}
                    >
                    <AccordionSummary 
                        expandIcon={<ExpandMoreIcon />} 
                        aria-controls={`step1-content`} 
                        id={`step1-header`}
                        >
                        {<p><b>Step 1</b></p>}
                    </AccordionSummary>
                      <AccordionDetails>
                          <ChooseFile onCustomFileSelected={handleCustomFileSelected}
                                      onSampleFileSelected={handleSampleFileSelected}
                                      selectedSampleFileName={sampleFileSelected}
                                      selectedFileName={customFileSelected?.name} showOptionToChooseCustomFile={true}/>
                          <button className='next-step-button'
                                  disabled={!fileSelected}
                                  title={`${!fileSelected ? 'Please select a file to move to the next step' : ''}`}
                                  onClick={handleNextStep}>
                              <p>Next Step</p>
                          </button>
                      </AccordionDetails>
                  </StepsAccordion>
                  <div className='divider'/>
                  <StepsAccordion
                    expanded={expandedStep2}
                    onChange={handleChangeStep2}
                    >
                    <AccordionSummary 
                        expandIcon={<ExpandMoreIcon />} 
                        aria-controls={`step2-content`} 
                        id={`step2-header`}
                        >
                        {<p><b>Step 2</b></p>}
                    </AccordionSummary>
                      <AccordionDetails>
                          <ChooseCriteriaOrScoreCard
                              scoreCards={scoreCards}
                              scoreCardName={scoreCardName}
                              onScoreCardNameChange={handleScoreCardNameChange}
                              onSelectCriteria={handleCriteriaSelection}
                              selectedCriteria={criteriaIdsSelected}
                              onCreateScoreCard={createScoreCard}
                              selectedScoreCardId={selectedScoreCardId}
                              onSelectStoryCard={handleStoryCardSelect}
                              criteriasAvailable={criteriasAvailable}
                              onCreateCriteria={createCriteria}
                              isLoading={isLoading}
                          />
                      </AccordionDetails>
                  </StepsAccordion>
              </div>
              <div className={"get-call-score-button"}>
                  <button className={"blue-button"}
                          disabled={disableGenerateScoreButton || isLoading || !selectedScoreCardId}
                          title={`${disableGenerateScoreButton ? 'Please select file and criteria/score card to generate call score' : ''}`}
                          onClick={handleGenerateCallScore}
                  >
                      {isLoading ? <div className="loading-spinner"></div> : 'Generate Score'}
                  </button>
              </div>
          </div>
          <div className={"call-score-details"}>
              <div className={"call-score-header"}>
                  <div className={"call-score-title"}>{evaluateAiAgent ? `Evaluate AI Agent call` : `Evaluate human call`}</div>
                  <button className={"back-to-home"} 
                  onClick={navigateToCallScore}
                  disabled={isLoading}
                  >
                    <p>Back to Home</p>
                  </button>
              </div>
              <HumanCallScoreReport conversationId={conversationId} jobId={jobId} isProcessingAsyncApiRequest={isLoading} setIsLoading={setIsLoading} />
          </div>
      </div>
    );
  };


export default HumanCallScore